import { createNativeCommerce } from './flow-native-commerce.js';

function init() {
  const bridge = window.FlowPreview, settings = window.FLOW_NATIVE_SETTINGS || {};
  if (!bridge) return;
  const button = document.getElementById('shopify-checkout'), status = document.getElementById('shopify-status');
  const panel = document.getElementById('shopify-review');
  const persistentStatus = document.createElement('p'); persistentStatus.setAttribute('role','status');
  persistentStatus.style.marginTop = '18px'; persistentStatus.style.lineHeight = '1.6';
  document.getElementById('bag-dialog').append(persistentStatus);
  const currency = settings.currency || 'USD';
  const money = (cents, code = currency) => new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100);
  let api = null, snapshot = null, busy = false, reviewed = null, connectionError = false;
  const retryControls = ['bag-dialog', 'add-to-bag'].map(id => {
    const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'button outline';
    retry.textContent = 'TRY AGAIN'; retry.style.display = 'none'; retry.style.marginTop = '12px';
    retry.addEventListener('click', () => start());
    const anchor = document.getElementById(id); if (id === 'add-to-bag') anchor.after(retry); else anchor.append(retry);
    return retry;
  });
  const say = message => { status.textContent = message; persistentStatus.textContent = message; };
  const clearReview = () => { reviewed = null; panel.replaceChildren(); panel.hidden = true; };
  function refresh() {
    const selection = bridge.getSelection(), mapping = api?.mapping;
    const catalog = bridge.getCatalog();
    const pricesFor = (product, variant) => (variant?.sizes || product?.sizes || []).map(size =>
      mapping?.get({ productId: product.id, variantId: variant.id, size })?.price).filter(p => p !== undefined);
    if (mapping) bridge.updatePrices(catalog.products.flatMap(product => product.variants.flatMap(variant => {
      const prices = pricesFor(product, variant);
      return prices.length ? [{ productId: product.id, variantId: variant.id, cents: Math.min(...prices), available: (variant.sizes || product.sizes).some(size => mapping.get({productId: product.id,variantId: variant.id,size})?.available) }] : [];
    })));
    for (const option of document.querySelectorAll('#size-options [data-size]'))
      option.disabled = busy || !mapping?.get({ ...selection, size: option.dataset.size })?.available;
    const add = document.getElementById('add-to-bag');
    const live = selection && mapping?.get(selection);
    const selectedProduct = selection && catalog.products.find(p => p.id === selection.productId);
    const selectedVariant = selectedProduct?.variants.find(v => v.id === selection.variantId);
    const anyAvailable = selectedVariant && (selectedVariant.sizes || selectedProduct.sizes).some(size => mapping?.get({...selection,size})?.available);
    add.disabled = busy || !api || !anyAvailable || (!!selection?.size && !live?.available);
    add.textContent = busy ? 'UPDATING BAG…' : !api ? connectionError ? 'TEMPORARILY UNAVAILABLE' : 'ORDERING OPENS SOON' : !anyAvailable ? 'SOLD OUT' : selection?.size && !live?.available ? 'SIZE UNAVAILABLE' : 'ADD TO BAG +';
    retryControls.forEach(retry => { retry.style.display = connectionError && settings.orderingEnabled ? 'flex' : 'none'; retry.disabled = busy; });
    if (live) document.getElementById('product-price').textContent = money(live.price);
    else if (selection && mapping) {
      const product = catalog.products.find(p => p.id === selection.productId), variant = product?.variants.find(v => v.id === selection.variantId);
      const prices = pricesFor(product, variant);
      document.getElementById('product-price').textContent = prices.length && prices.every(p => p === prices[0]) ? money(prices[0]) : 'Select a size for its price';
    }
    for (const card of document.querySelectorAll('.product-card')) {
      const productId = card.querySelector('[data-product]')?.dataset.product;
      const product = bridge.getCatalog().products.find(p => p.id === productId);
      const variant = product?.variants[Number(card.querySelector('[data-index].active')?.dataset.index || 0)];
      const prices = (variant?.sizes || product?.sizes || []).map(size => mapping?.get({ productId, variantId: variant?.id, size })?.price).filter(p => p !== undefined);
      if (prices.length) card.querySelector('.product-price').textContent = prices.every(p => p === prices[0]) ? money(prices[0]) : 'Select size';
      if (mapping && variant && !(variant.sizes || product.sizes).some(size => mapping.get({productId,variantId:variant.id,size})?.available)) card.querySelector('.product-tag').textContent = 'SOLD OUT';
    }
    const hero = catalog.products.find(p => p.id === 'original-hoodie'), heroPrices = pricesFor(hero, hero?.variants[0]);
    if (heroPrices.length) document.getElementById('hero-price').textContent = heroPrices.every(p => p === heroPrices[0]) ? money(heroPrices[0]) : 'Select size';
    if (snapshot) {
      const rows = [...document.querySelectorAll('#bag-items .bag-line')];
      snapshot.cart.items.forEach((line, i) => {
        const target = rows[i]?.querySelector('.bag-line-controls > span');
        if (target) target.textContent = money(line.final_line_price, snapshot.cart.currency);
      });
      document.getElementById('bag-total').textContent = money(snapshot.cart.total_price, snapshot.cart.currency);
    }
    document.querySelectorAll('[data-bag-action]').forEach(control => {
      const quantity = snapshot?.cart.items[Number(control.dataset.line)]?.quantity;
      control.disabled = busy || !api || (control.dataset.bagAction === 'minus' && quantity === 1) ||
        (control.dataset.bagAction === 'plus' && quantity === 99);
    });
    button.disabled = busy || !api || !snapshot?.bag.length;
    button.textContent = busy ? 'CHECKING YOUR BAG…' : !api ? connectionError ? 'TEMPORARILY UNAVAILABLE' : 'CHECKOUT COMING SOON' : reviewed ? 'CONTINUE TO CHECKOUT ↗' : 'REVIEW CHECKOUT';
  }
  function apply(next) { snapshot = next; bridge.replaceBag(next.bag); refresh(); }
  async function update(action, message, errorTarget = null) {
    if (busy || !api) return;
    if (errorTarget) errorTarget.textContent = '';
    busy = true; clearReview(); refresh();
    try { apply(await action()); say(message); return true; }
    catch (error) {
      const message = error.message || 'Your bag could not be updated.';
      say(message); if (errorTarget) errorTarget.textContent = message;
      try { apply(await api.read()); } catch { /* Keep the last verified bag; no automatic mutation retry. */ }
      return false;
    } finally { busy = false; refresh(); }
  }
  document.addEventListener('click', event => {
    const control = event.target.closest?.('#add-to-bag, [data-bag-action], #shopify-checkout');
    if (!control) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy || !api) return;
    if (control.id === 'add-to-bag') {
      const selection = bridge.getSelection();
      if (!selection?.size) { document.getElementById('size-error').textContent = 'Choose a size first.'; return; }
      update(() => api.add(selection), 'Added to your bag.', document.getElementById('size-error')).then(success => {
        if (success) {
          document.getElementById('product-dialog').close(); window.Flow.toast('Added to your bag.');
        }
      });
    } else if (control.dataset.bagAction) {
      const line = snapshot?.cart.items[Number(control.dataset.line)]; if (!line) return;
      const quantity = control.dataset.bagAction === 'remove' ? 0 : line.quantity + (control.dataset.bagAction === 'plus' ? 1 : -1);
      update(() => api.change(line.key, quantity), 'Your bag is up to date.');
    } else checkout();
  }, true);
  function showReview(current) {
    panel.replaceChildren();
    const heading = document.createElement('p'); heading.textContent = 'Review your current order'; panel.append(heading);
    current.cart.items.forEach(line => {
      const row = document.createElement('p'); row.textContent = `${line.product_title} / ${line.variant_title} × ${line.quantity} — ${money(line.final_line_price, current.cart.currency)}`; panel.append(row);
    });
    const total = document.createElement('p'); total.textContent = `Subtotal after discounts: ${money(current.cart.total_price, current.cart.currency)}. Shipping and taxes are calculated at checkout.`; panel.append(total); panel.hidden = false;
  }
  async function checkout() {
    busy = true; refresh();
    try {
      const current = await api.review(); apply(current);
      if (reviewed && reviewed === current.signature) {
        const form = document.createElement('form'); form.method = 'post'; form.action = settings.cartUrl;
        const submit = document.createElement('input'); submit.type = 'hidden'; submit.name = 'checkout'; submit.value = 'Checkout';
        form.append(submit); document.body.append(form); form.submit();
      } else {
        const changed = !!reviewed; reviewed = current.signature; showReview(current);
        say(changed ? 'Your bag changed. Review the updated items and total before continuing.' : 'Review the items, sizes and total, then continue to Shopify checkout.');
      }
    } catch (error) { clearReview(); say(error.message || 'Checkout could not be prepared.'); }
    finally { busy = false; refresh(); }
  }
  for (const event of ['flow:detail-change', 'flow:render', 'flow:bag-render']) window.addEventListener(event, refresh);
  const nativeBag = document.createElement('a'); nativeBag.href = settings.cartUrl || '/cart'; nativeBag.textContent = 'View full bag ↗';
  nativeBag.style.display = 'block'; nativeBag.style.marginTop = '18px'; document.getElementById('bag-dialog').append(nativeBag);
  document.getElementById('open-bag').addEventListener('click', () => { if(api && !busy) update(() => api.read(), 'Your bag is up to date.'); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden && api && !busy) update(() => api.read(), 'Your bag is up to date.'); });
  document.getElementById('download-bag').addEventListener('click', event => {
    event.preventDefault(); event.stopImmediatePropagation();
    if (!snapshot) return;
    const lines = snapshot.cart.items.map(line => `${line.product_title} | ${line.variant_title} | Qty ${line.quantity} | ${money(line.final_line_price, snapshot.cart.currency)}`);
    window.Flow.download('FLOW-my-bag.txt', `THE FLOW PROJECT\nSaved selection\n\n${lines.join('\n')}\n\nSubtotal after discounts: ${money(snapshot.cart.total_price, snapshot.cart.currency)}\nShipping and taxes excluded. Confirm current prices at checkout.\nThis is not an order or payment receipt.\n`);
  }, true);
  async function start() {
    if (busy) return;
    if (!settings.orderingEnabled) { say('The collection is being prepared. Ordering opens soon.'); return; }
    busy = true; connectionError = false; clearReview(); refresh();
    document.getElementById('size-error').textContent = '';
    try {
      api = createNativeCommerce({ catalog: bridge.getCatalog(), bindings: window.FLOW_NATIVE_BINDINGS,
        root: settings.root || '/' });
      apply(await api.read()); say('Your bag is ready.');
    } catch (error) {
      api = null; connectionError = true;
      const message = error.message || 'Ordering is temporarily unavailable.';
      say(message); document.getElementById('size-error').textContent = message;
    } finally { busy = false; refresh(); }
  }
  const params = new URLSearchParams(location.search);
  let target = params.get('id'), targetColor = params.get('color');
  if (settings.currentProductId) for (const [localId, variants] of Object.entries(window.FLOW_NATIVE_BINDINGS || {}))
    for (const [color, value] of Object.entries(variants)) if (String(value.product?.id) === String(settings.currentProductId)) { target = localId; targetColor = color; }
  if (target) bridge.openProduct(target, targetColor);
  refresh();
  start();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
